import { OrderNoteGetRequest } from '@trukt/tms-api/NoteService';
import { createKey } from './createKey';

const keyHandler = createKey('notes');

export const noteServiceKeys = {
  key: keyHandler.key,
  getOrderNotes: keyHandler.createMethod<OrderNoteGetRequest>(),
};
